export default "__VITE_ASSET__DLYWXV0H__"